import { c as _c } from "react/compiler-runtime";
import { DocumentCheckIcon } from '@heroicons/react/24/solid';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import { useTRPC } from '@/app/api/trpc/config';
import type { UpdateOrganizerAvailabilityInputDTO } from '@/backend/modules/phone-call-booking/endpoints/mutations/update-organizer-availability/input.dto';
import { Button } from '@/frontend/design-system/actions/Button';
import { showErrorToastWithContactFormLink } from '@/frontend/design-system/feedback/Toaster/ToasterError';
interface SaveButtonProps {
  selectedEventsMap: Map<string, CalendarEvent[]>;
  refetchQueries: (() => Promise<unknown>)[];
}
export function SaveButton(t0) {
  const $ = _c(18);
  const {
    selectedEventsMap,
    refetchQueries
  } = t0;
  const trpc = useTRPC();
  let t1;
  if ($[0] !== trpc.phoneCallBooking.getEventsAvailableForBooking) {
    t1 = trpc.phoneCallBooking.getEventsAvailableForBooking.queryOptions();
    $[0] = trpc.phoneCallBooking.getEventsAvailableForBooking;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getEventsAvailableForBookingQuery = useQuery(t1);
  let t2;
  if ($[2] !== getEventsAvailableForBookingQuery || $[3] !== refetchQueries || $[4] !== trpc.phoneCallBooking.updateOrganizerAvailability) {
    let t3;
    if ($[6] !== getEventsAvailableForBookingQuery || $[7] !== refetchQueries) {
      t3 = async () => {
        await Promise.all(refetchQueries.map(_temp));
        await getEventsAvailableForBookingQuery.refetch();
      };
      $[6] = getEventsAvailableForBookingQuery;
      $[7] = refetchQueries;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = trpc.phoneCallBooking.updateOrganizerAvailability.mutationOptions({
      onSuccess: t3
    });
    $[2] = getEventsAvailableForBookingQuery;
    $[3] = refetchQueries;
    $[4] = trpc.phoneCallBooking.updateOrganizerAvailability;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const mutation = useMutation(t2);
  let t3;
  if ($[9] !== mutation || $[10] !== selectedEventsMap) {
    t3 = async () => {
      const input = {
        events: [...selectedEventsMap.values()].flat().map(_temp2)
      };
      try {
        await mutation.mutateAsync(input);
      } catch {
        showErrorToastWithContactFormLink();
      }
    };
    $[9] = mutation;
    $[10] = selectedEventsMap;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleClick = t3;
  const isLoading = mutation.status === "pending";
  let t4;
  if ($[12] !== isLoading) {
    t4 = !isLoading && <DocumentCheckIcon />;
    $[12] = isLoading;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== handleClick || $[15] !== isLoading || $[16] !== t4) {
    t5 = <Button className="w-fit self-end" onClick={handleClick} loading={isLoading}>{t4}Zapisz dostępność</Button>;
    $[14] = handleClick;
    $[15] = isLoading;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp2(e) {
  return {
    id: e.id ?? "",
    startTime: e.startTime,
    isRecurring: e.isRecurring ?? false
  };
}
function _temp(f) {
  return f();
}